import React, {Component} from "react";
import {withRouter, RouteComponentProps} from "react-router-dom";

// Styles
import "./Attributes.component.scss";

// Components
import {Components} from "@webtech/webtech-ui-react/build/webtech-ui";

// Store
import {ActionCreator} from "../../../../../actions/actions";
import {connect} from "react-redux";
import {gamesStoreSelectors} from "../../../store/store";
import {GamesActionCreators} from "../../../actions/actionCreators";

import Drawer from "./../../../../../utils/Drawer/Drawer.component";
import FormAttribute from "./Form/FormAttribute.component";
import {GameNavigation} from "../GameNavigation/GameNavigation.component";
import {CreationModes} from "../../../reducers/gameAttributes.reducer";
import {checkPermission} from "../../../../../utils/Authorization/authorization";


export interface AttributesProps extends RouteComponentProps {
    getGameAttributes: ActionCreator;
    getClients: ActionCreator;
    getGameFeatures: ActionCreator;
    getGameSeries: ActionCreator;
    getGamePlaftorms: ActionCreator;
    getGameTypes: ActionCreator;
    getGameTrademarks: ActionCreator;
    editGameAttribute: ActionCreator;
    gameAttributesLoading: boolean;
    gameAttrFeatures: any;
    gameAttrFeaturesLoading: boolean;
    gameAttrSeries: any;
    gameAttrSeriesLoading: boolean;
    gameAttrPlatforms: any;
    gameAttrPlatformsLoading: boolean;
    gameAttrTypes: any;
    gameAttrTypesLoading: boolean;
    gameAttrTrademarks: any;
    gameAttrTrademarksLoading: boolean;
    clients: any;
    clientsLoading: boolean;
    createGameAttribute: ActionCreator;
    updateAttrCreationMode: ActionCreator;
    attrCreationMode: string | null;
    attrCreationLoading: boolean;


}

export interface AttributesState {
    currentEdit: any;
    currentAdd: any;
    currentClient: any;
}

class Attributes extends Component<AttributesProps, AttributesState> {
    clientSelector: React.RefObject<Components.SelectMenu>;

    constructor(props) {
        super(props);

        this.state = {
            currentEdit: null,
            currentAdd: null,
            currentClient: null
        };

        this.clientSelector = React.createRef();

        this.props.getGameAttributes();
        this.props.getClients();
    }


    onChangeClient = (value) => {
        this.props.getGameSeries(value);
        this.props.getGameTrademarks(value);
        this.props.getGameFeatures(value);
        this.props.getGamePlaftorms(value);
        this.props.getGameTypes(value);
        this.setState({
            currentClient: value
        })
    };

    closeDrawer = () => {
        if (!this.props.attrCreationLoading) {
            this.props.updateAttrCreationMode(null);
            this.setState({
                currentAdd: null,
                currentEdit: null
            });
        }
    };

    getTitle = () => {
        let title = this.props.attrCreationMode == CreationModes.ADD ? "Add " : "Edit ";
        switch (this.props.attrCreationMode == CreationModes.ADD ? this.state.currentAdd.values.key : this.state.currentEdit.values.key) {
            case "series_id":
                title = title + "Series";
                break;
            case "trademark_id":
                title = title + "Trademark";
                break;
            case "feature_id":
                title = title + "Feature";
                break;
            case "platform_id":
                title = title + "Platform";
                break;
            case "type_id":
                title = title + "Type";
                break;
            default:
                break;
        }
        return title;
    };

    updateCreation = (values, isValid) => {
        if (this.props.attrCreationMode == CreationModes.EDIT) {
            this.setState({
                currentEdit: {
                    values: values,
                    isValid: isValid
                },
                currentAdd: null
            });
        } else if (this.props.attrCreationMode == CreationModes.ADD) {
            this.setState({
                currentAdd: {
                    values: values,
                    isValid: isValid
                },
                currentEdit: null
            });
        }
    };

    saveAttribute = () => {
        if (this.props.attrCreationMode == CreationModes.EDIT) {
            this.props.editGameAttribute(
                this.state.currentEdit.values,
                this.clientSelector.current.state[
                    "value"
                    ]
            );
        } else if (this.props.attrCreationMode == CreationModes.ADD) {
            this.props.createGameAttribute(
                this.state.currentAdd.values,
                this.clientSelector.current.state[
                    "value"
                    ]
            );
        }
        ;
    }

    renderAttribute = (title, isLoading, attr, id_key) => {
        const clients = {};
        if (this.props.clients && this.props.clients.results && this.props.clients.results.length > 0) {
            this.props.clients.results.map(client => {
                clients[client.id] = client.name;
            });
        }
        return (
            <div className="attr-container">
                <div>
                    <div className="attr-header">
                        <h4>{title}</h4>
                        {(process.env.REACT_APP_BUILD_ENV === "PROD" || !process.env.REACT_APP_BUILD_ENV) && checkPermission("manage_game_attributes") && (
                            <button
                                className="btn tooltip-icon"
                                onClick={() => {
                                    this.props.updateAttrCreationMode(
                                        CreationModes.ADD
                                    );

                                    this.setState({
                                        currentAdd: {
                                            values: {key: id_key},
                                            isValid: false
                                        },
                                        currentEdit: null
                                    })
                                }}
                            >
                                <span className="tooltip-text">{`Add ${title}`}</span>
                                <i className="icon-plus-light"></i>
                            </button>
                        )}
                    </div>
                    <div className="attr-body">
                        {!isLoading ? (
                            attr.data && attr.data.results && attr.data.results.length > 0 ? (
                                <table>
                                    <thead>
                                    <tr>
                                        <th style={{width: "40px"}}>
                                            Id
                                        </th>
                                        <th>Name</th>
                                        <th style={{width: "50px"}}/>
                                        <th style={{width: "40px"}}/>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {attr.data.results.map((item, index) => {
                                        return (
                                            <tr key={index}>
                                                <td
                                                    style={{
                                                        width: "40px"
                                                    }}
                                                >
                                                    {item[id_key]}
                                                </td>
                                                <td>{item.name}</td>
                                                <td
                                                    className="client-column"
                                                    style={{
                                                        width: "50px"
                                                    }}
                                                >
                                                    {
                                                        clients[item.client.id]
                                                    }
                                                </td>
                                                <td
                                                    style={{
                                                        width: "40px"
                                                    }}
                                                >
                                                    {(process.env.REACT_APP_BUILD_ENV === "PROD" || !process.env.REACT_APP_BUILD_ENV) && (
                                                        <button
                                                            onClick={() => {
                                                                this.props.updateAttrCreationMode(
                                                                    CreationModes.EDIT
                                                                );

                                                                this.setState({
                                                                    currentEdit:
                                                                        {
                                                                            values: {
                                                                                key: id_key,
                                                                                id: item.id,
                                                                                name: item.name,
                                                                                attr_id: item[id_key],
                                                                                client_id: item.client.id
                                                                            },
                                                                            isValid:
                                                                                false
                                                                        },
                                                                    currentAdd:
                                                                        null
                                                                })
                                                            }}
                                                            className="btn btn-edit tooltip-icon"
                                                        >
                                                            <span className="tooltip-text">Edit</span>
                                                            <i className="icon-pencil-alt-light"></i>
                                                        </button>
                                                    )}
                                                </td>
                                            </tr>
                                        );
                                    })}
                                    </tbody>
                                </table>
                            ) : (
                                <div className="client-list-loading">
                                    <span className="no-items">
                                        No items found.
                                    </span>
                                </div>
                            )
                        ) : (
                            <div className="client-list-loading">
                                <Components.LoadingRipple
                                    width={"100px"}
                                    height={"100px"}
                                />
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    };

    render() {
        const isLoading = this.props.clientsLoading;

        return (
            <div id="attributes" className="content">
                <GameNavigation/>
                <div className="container attribute-filter">
                    <div id="AttrPageFiltersBox">
                        <div className="row">
                            <div className="adjustable-filters">
                                <div className="attr-filter">
                                    <label>Client</label>
                                    <Components.SelectMenu
                                        noValueLabel="All"
                                        ref={this.clientSelector}
                                        items={
                                            this.props.clients &&
                                            this.props.clients.results &&
                                            this.props.clients.results.length > 0
                                                ? [
                                                    {
                                                        label: "All",
                                                        value: null
                                                    }
                                                ].concat(
                                                    this.props.clients.results.map(
                                                        (client, index) => {
                                                            return {
                                                                label: (
                                                                    <div
                                                                        key={`${index}-${client.id}`}
                                                                        className="select-client"
                                                                    >
                                                                        {client.name}
                                                                    </div>
                                                                ),
                                                                value: client.id
                                                            };
                                                        }
                                                    )
                                                )
                                                : [
                                                    {
                                                        label: "All",
                                                        value: null
                                                    }
                                                ]
                                        }
                                        onChange={value => {
                                            this.onChangeClient(value);
                                        }}
                                        value={
                                            this.state.currentClient
                                        }
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container">
                    {!isLoading ? (
                        <React.Fragment>
                            {this.renderAttribute(
                                "Series",
                                this.props.gameAttrSeriesLoading,
                                this.props.gameAttrSeries,
                                "series_id"
                            )}

                            {this.renderAttribute(
                                "Trademarks",
                                this.props.gameAttrTrademarksLoading,
                                this.props.gameAttrTrademarks,
                                "trademark_id"
                            )}
                            <div className="attr-container">
                                {this.renderAttribute(
                                    "Features",
                                    this.props.gameAttrFeaturesLoading,
                                    this.props.gameAttrFeatures,
                                    "feature_id"
                                )}

                                {this.renderAttribute(
                                    "Platforms",
                                    this.props.gameAttrPlatformsLoading,
                                    this.props.gameAttrPlatforms,
                                    "platform_id"
                                )}

                                {this.renderAttribute(
                                    "Game Types",
                                    this.props.gameAttrTypesLoading,
                                    this.props.gameAttrTypes,
                                    "type_id"
                                )}
                            </div>
                        </React.Fragment>
                    ) : (
                        <div className="client-list-loading">
                            <Components.LoadingRipple
                                width={"100px"}
                                height={"100px"}
                            />
                        </div>
                    )}
                </div>
                {
                    (this.props.attrCreationMode == CreationModes.EDIT ||
                        this.props.attrCreationMode == CreationModes.ADD) && (
                        <Drawer title={this.getTitle()} onClose={this.closeDrawer}>
                            <FormAttribute
                                clients={this.props.clients.results}
                                attribute={
                                    this.props.attrCreationMode == CreationModes.EDIT
                                        ? this.state.currentEdit
                                        : this.state.currentAdd
                                }
                                creationMode={this.props.attrCreationMode}
                                action={this.updateCreation}
                                save={this.saveAttribute}
                                isLoading={this.props.attrCreationLoading}
                            />
                        </Drawer>
                    )
                }
            </div>
        );
    }
}

const mapStateToProps = state => ({
    gameAttributesLoading: gamesStoreSelectors.gameAttributesLoading(state),
    gameAttrFeatures: gamesStoreSelectors.gameAttrFeatures(state),
    gameAttrFeaturesLoading: gamesStoreSelectors.gameAttrFeaturesLoading(state),
    gameAttrSeries: gamesStoreSelectors.gameAttrSeries(state),
    gameAttrSeriesLoading: gamesStoreSelectors.gameAttrSeriesLoading(state),
    gameAttrPlatforms: gamesStoreSelectors.gameAttrPlatforms(state),
    gameAttrPlatformsLoading:
        gamesStoreSelectors.gameAttrPlatformsLoading(state),
    gameAttrTypes: gamesStoreSelectors.gameAttrTypes(state),
    gameAttrTypesLoading: gamesStoreSelectors.gameAttrTypesLoading(state),
    gameAttrTrademarks: gamesStoreSelectors.gameAttrTrademarks(state),
    gameAttrTrademarksLoading:
        gamesStoreSelectors.gameAttrTrademarksLoading(state),
    clients: gamesStoreSelectors.clients(state),
    clientsLoading: gamesStoreSelectors.clientsLoading(state),
    attrCreationMode: gamesStoreSelectors.attrCreationMode(state),
    attrCreationLoading: gamesStoreSelectors.attrCreationLoading(state),
});

const mapDispatchToProps = {
    getGameAttributes: GamesActionCreators.getGameAttributes,
    getClients: GamesActionCreators.getClients,
    getGameFeatures: GamesActionCreators.getGameFeatures,
    getGameSeries: GamesActionCreators.getGameSeries,
    getGamePlaftorms: GamesActionCreators.getGamePlaftorms,
    getGameTypes: GamesActionCreators.getGameTypes,
    getGameTrademarks: GamesActionCreators.getGameTrademarks,
    editGameAttribute: GamesActionCreators.editGameAttribute,
    createGameAttribute: GamesActionCreators.createGameAttribute,
    updateAttrCreationMode: GamesActionCreators.updateAttrCreationMode
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(Attributes));
